import { cn } from "@tsi/ui";

/**
 * Skeleton de uma linha de texto: um <span> inline com a altura da fonte do pai, então a linha
 * ocupa exatamente a altura do texto que vai entrar (e pode ficar dentro de <p> e <h2>).
 */
export function LinhaSkeleton({ className }: { className?: string }) {
  return <span aria-hidden className={cn("inline-block h-[0.8em] animate-pulse rounded-md bg-border align-middle", className)} />;
}
